export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" stroke=\"#00809D\" stroke-width=\"2\" d=\"M22 12h5v24h-5V12zm10 7h5v17h-5V19z\" clip-rule=\"evenodd\"/><path stroke=\"#00809D\" stroke-width=\"2\" d=\"M11 25h5v11h-5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};